import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { useAuth } from "@/auth";
import { AppShell } from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import OverviewPage from "@/pages/OverviewPage";
import SitesPage from "@/pages/SitesPage";
import ServersPage from "@/pages/ServersPage";
import SiteDetailPage from "@/pages/SiteDetailPage";
import UploadPage from "@/pages/UploadPage";
import InstallerPage from "@/pages/InstallerPage";
import SettingsPage from "@/pages/SettingsPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-background text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

export default function App() {
  return (
    <div className="min-h-screen bg-background text-foreground app-noise">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <Protected>
              <AppShell>
                <Routes>
                  <Route path="/" element={<OverviewPage />} />
                  <Route path="/sites" element={<SitesPage />} />
                  <Route path="/servers" element={<ServersPage />} />
                  <Route path="/sites/:id" element={<SiteDetailPage />} />
                  <Route path="/upload" element={<UploadPage />} />
                  <Route path="/installer" element={<InstallerPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </AppShell>
            </Protected>
          }
        />
      </Routes>
    </div>
  );
}
